import { PluginKey } from '@tiptap/pm/state'

export const EditorEventHandlerPluginOrder = {
  MAIN: 1000, // handlers should run after all other handlers
  TRANSLATION_HINT: 1,
}

export const EditorEventHandlerPluginKey = {
  MAIN: new PluginKey('EVENT_HANDLER_PLUGIN_KEY'),
  TRANSLATION_HINT: new PluginKey('TRANSLATION_HINT'),
}
